export const FETCH_BACKUP_PLANS_START = "FETCH_BACKUP_PLANS_START";
export const FETCH_BACKUP_PLANS_SUCCESS = "FETCH_BACKUP_PLANS_SUCCESS";
export const ENABLE_BACKUP_PLAN_START = "ENABLE_BACKUP_PLAN_START";
export const DISABLE_BACKUP_PLAN_START = "DISABLE_BACKUP_PLAN_START";
export const TOGGLE_BACKUP_PLANS_CHECKLIST = "TOGGLE_BACKUP_PLANS_CHECKLIST";
export const DELETE_BACKUP_PLAN_START = "DELETE_BACKUP_PLAN_START";
export const DELETE_BACKUP_PLAN_SUCCESS = "DELETE_BACKUP_PLAN_SUCCESS";
export const ENABLE_BACKUP_PLAN_SUCCESS = "ENABLE_BACKUP_PLAN_SUCCESS";
export const DISABLE_BACKUP_PLAN_SUCCESS = "DISABLE_BACKUP_PLAN_SUCCESS";
export const FETCH_BACKUP_PLANS_SETTING_START =
  "FETCH_BACKUP_PLANS_SETTING_START";
export const FETCH_BACKUP_PLANS_SETTING_SUCCESS =
  "FETCH_BACKUP_PLANS_SETTING_SUCCESS";
export const SAVE_BACKUP_PLANS_SETTING_START =
  "SAVE_BACKUP_PLANS_SETTING_START";
export const SAVE_BACKUP_PLANS_SETTING_SUCCESS =
  "SAVE_BACKUP_PLANS_SETTING_SUCCESS";
export const CLEAN_BACKUP_PLAN_CACHE = "CLEAN_BACKUP_PLAN_CACHE";
export const SET_CLEAN_BACKUP_PLAN_CACHE = "SET_CLEAN_BACKUP_PLAN_CACHE";
export const CREATE_NEW_BACKUP_PLAN_START = "CREATE_NEW_BACKUP_PLAN_START";
export const CREATE_NEW_BACKUP_PLAN_SUCCESS = "CREATE_NEW_BACKUP_PLAN_SUCCESS";
export const RESET_LOADING_SETTINGS = "RESET_LOADING_SETTINGS";
export const FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_START =
  "FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_START";
export const FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_SUCCESS =
  "FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_SUCCESS";
export const SAVE_BACKUP_PLAN_SETTINGS_FAILURE =
  "SAVE_BACKUP_PLAN_SETTINGS_FAILURE";
export const CHANGE_BACKUP_PLANS_CHECKLIST = "CHANGE_BACKUP_PLANS_CHECKLIST";
export const BACKUP_PLANS_API_DOWN = "BACKUP_PLANS_API_DOWN";
